// ! ayozqala qadimiy qal'asi
import ayozqala1 from "../../photos/uzb_qq_ayozqala1.webp";
import ayozqala2 from "../../photos/uzb_qq_ayozqala2.webp";
import ayozqala3 from "../../photos/uzb_qq_ayozqala3.webp";

// ! toproqqala qadimiy shahri
import toproqqala1 from "../../photos/uzb_qq_toproqqala1.webp";
import toproqqala2 from "../../photos/uzb_qq_toproqqala2.webp";
import toproqqala3 from "../../photos/uzb_qq_toproqqala3.webp";

// ! mizdaxon nekropoli
import mizdaxon1 from "../../photos/uzb_qq_mizdaxon1.webp";
import mizdaxon2 from "../../photos/uzb_qq_mizdaxon2.webp";
import mizdaxon3 from "../../photos/uzb_qq_mizdaxon3.webp";

// ! savitskiy san'at muzeyi
import savitskiy1 from "../../photos/uzb_qq_savitskiy1.webp";
import savitskiy2 from "../../photos/uzb_qq_savitskiy2.webp";
import savitskiy3 from "../../photos/uzb_qq_savitskiy3.webp";

// ! chilpiq dahmasi
import chilpiq1 from "../../photos/uzb_qq_chilpiq1.webp";
import chilpiq2 from "../../photos/uzb_qq_chilpiq2.webp";
import chilpiq3 from "../../photos/uzb_qq_chilpiq3.webp";

// ! qo'yqirilgan qala
import qoyqirilgan1 from "../../photos/uzb_qq_qoyqirilgan1.webp";
import qoyqirilgan2 from "../../photos/uzb_qq_qoyqirilgan2.webp";
import qoyqirilgan3 from "../../photos/uzb_qq_qoyqirilgan3.webp";

const qoraqalpogiston = {
    uz: {
        key: "qoraqalpogiston",
        title: "Qoraqalpog‘iston — cho‘l ichidagi qadimiy qal’alar diyori",

        intro: `
Qoraqalpog‘iston Respublikasi — Amudaryoning quyi oqimida, Qizilqum va Ustyurt platosi orasida joylashgan noyob hudud.
Bu yer "Ellik qal’a" nomi bilan mashhur bo‘lgan qadimiy Xorazm qal’alari va zamonaviy jahon san’ati muzeyi bilan tanilgan.
  `,

        history: `
Qoraqalpog‘iston hududi qadimda Xorazm sivilizatsiyasining bir qismi bo‘lgan bo‘lib, uning tarixi miloddan avvalgi VII–VI asrlarga borib taqaladi. Amudaryoning quyi oqimida joylashgan bu yer Xorazmshohlar davlatining muhim mudofaa va madaniy hududi hisoblangan.

Hudud "Ellik qal’a" nomi bilan mashhur bo‘lib, bu yerda yuzlab qadimiy qal’a va istehkomlar qurilgan — ular Xorazm vohasini ko‘chmanchi qabilalar hujumidan himoya qilgan.

Miloddan avvalgi IV–I asrlarda bu hududda kuchli davlat tuzilmalari mavjud bo‘lgan, keyinchalik Kushon va Afrig‘iylar sulolasi davrida ham mintaqa gullab-yashnagan. Zardushtiylik dini bu yerda keng tarqalgan bo‘lib, Chilpiq kabi dahma inshootlari shu davrdan qolgan.

O‘rta asrlarda mo‘g‘ullar istilosi va Amudaryo o‘zanining o‘zgarishi natijasida ko‘plab qadimiy shaharlar tashlab ketilgan va asta-sekin qumga ko‘milgan.

XX asrda Qoraqalpog‘iston o‘zining boy arxeologik merosi bilan bir qatorda, Igor Savitskiy tomonidan yig‘ilgan noyob avangard san’at kolleksiyasi bilan ham dunyoga tanildi.

Bugungi kunda mintaqa "cho‘ldagi qal’alar diyori" sifatida sayyohlar va tarixchilar uchun O‘zbekistonning eng sirli va o‘ziga xos burchaklaridan biri hisoblanadi.
`,
        sections: [
            {
                title: "Ayozqala qadimiy qal’asi",

                content: `
Ayozqala — Qoraqalpog‘istondagi eng mashhur va yaxshi saqlangan qadimiy qal’alardan biri bo‘lib, Qizilqum cho‘li o‘rtasida baland tepalikda joylashgan.

Bu majmua uch qismdan iborat bo‘lib, turli davrlarga oid mudofaa va yashash inshootlarini o‘z ichiga oladi.

Ayozqala o‘zining ulkan mudofaa devorlari va atrofdagi cho‘l manzarasi bilan Qoraqalpog‘istonning eng ta’sirchan yodgorligi hisoblanadi.
    `,

                details: `
Ayozqala majmuasi uch alohida qal’adan iborat bo‘lib, ular turli davrlarda qurilgan.

📌 Majmua tarkibi:
- Ayozqala 1 — miloddan avvalgi IV–III asrlarga oid harbiy qal’a
- Ayozqala 2 — IV–VI asrlarga oid feodal qasr-qal’a
- Ayozqala 3 — VII–VIII asrlarga oid yashash majmuasi

📌 Arxitektura xususiyatlari:
- Xom g‘ishtdan ishlangan qalin mudofaa devorlari
- Minoralar va kuzatuv nuqtalari
- Baland tepalikda strategik joylashuv

📌 Tarixiy ahamiyati:
- Xorazm vohasini ko‘chmanchilar hujumidan himoya qilgan
- Qadimgi Xorazm harbiy me’morchiligining namunasi
- Yurtboshi qal’alar tizimining muhim qismi bo‘lgan

Bugungi kunda Ayozqala yaqinida yurtalar (o‘tov) kompleksi tashkil etilgan bo‘lib, sayyohlar tunash imkoniyatiga ega.
    `,
                facts: [
                    "Nukus shahridan taxminan 90 km uzoqlikda joylashgan",
                    "Uch alohida qal’adan iborat majmua",
                    "Eng qadimgi qismi miloddan avvalgi IV asrga tegishli",
                    "Xom g‘ishtdan ishlangan mudofaa devorlari saqlangan",
                    "Xorazm harbiy me’morchiligining namunasi",
                    "Baland tepalikda strategik joylashgan",
                    "Ko‘chmanchilar hujumidan himoya vazifasini bajargan",
                    "Yaqinida turistik yurta-kemping tashkil etilgan",
                    "Qizilqum cho‘li manzarasi bilan mashhur",
                    "Qoraqalpog‘istonning eng ko‘p ziyorat qilinadigan qal’asi",
                    "Arxeologik jihatdan yaxshi saqlangan obyekt",
                    "Xorazmshohlar davlati mudofaa tizimining qismi",
                    "Kunbotarda ajoyib manzara hosil qiladi",
                    "Fotosuratchilar orasida mashhur maskan",
                    "\"Ellik qal’a\" tizimining eng mashhur vakili"
                ],
                images: [ayozqala1, ayozqala2, ayozqala3,]
            },

            {
                title: "Toproqqala qadimiy shahri",

                content: `
Toproqqala — qadimgi Xorazm davlatining poytaxti bo‘lgan yirik shahar xarobasi bo‘lib, mintaqadagi eng muhim arxeologik yodgorliklardan biri hisoblanadi.

Bu yerda topilgan saroy majmuasi va noyob topilmalar Xorazm sivilizatsiyasining yuksak darajasidan dalolat beradi.

Toproqqala arxeologlar tomonidan "cho‘l Pompeyi" deb ham ataladi, chunki u juda yaxshi saqlanib qolgan.
    `,

                details: `
Toproqqala I–IV asrlarda gullab-yashnagan bo‘lib, Xorazmshohlarning poytaxti sifatida xizmat qilgan.

📌 Saroy majmuasi:
- Uch qavatli ulkan saroy binosi
- "Qirollar zali", "raqqosalar zali" kabi maxsus xonalar
- Devorlarda saqlanib qolgan rangli suratlar va haykaltaroshlik

📌 Muhim topilmalar:
- Xorazm tilida yozilgan hujjatlar (Xorazm yozuvi namunalari)
- Shohlar va malikalar tasvirlangan haykalchalar
- Kundalik turmush buyumlari

📌 Tarixiy ahamiyati:
- Qadimgi Xorazm davlatchiligi markazi bo‘lgan
- Zardushtiylik dini bilan bog‘liq topilmalar aniqlangan
- Markaziy Osiyo tarixini o‘rganishda noyob manba

Shahar IV asrdan keyin poytaxt maqomini yo‘qotgan va asta-sekin tashlab ketilgan, biroq uning qoldiqlari juda yaxshi saqlanib qolgan.
    `,
                facts: [
                    "Beruniy tumani hududida joylashgan",
                    "I–IV asrlarda Xorazm poytaxti bo‘lgan",
                    "\"Cho‘l Pompeyi\" deb ham ataladi",
                    "Uch qavatli saroy majmuasi topilgan",
                    "Rangli devor suratlari saqlangan",
                    "Xorazm yozuvi namunalari topilgan",
                    "Shohlar va malikalar haykalchalari aniqlangan",
                    "Zardushtiylik diniga oid topilmalar bor",
                    "Markaziy Osiyo qadimiy tarixining muhim manbasi",
                    "Arxeologik qazishmalar XX asr o‘rtalarida boshlangan",
                    "Topilmalar Nukus va Toshkent muzeylarida saqlanadi",
                    "Xorazm davlatchiligi markazi bo‘lgan",
                    "IV asrdan keyin asta-sekin tashlab ketilgan",
                    "Juda yaxshi saqlangan holati bilan ajralib turadi",
                    "Qoraqalpog‘istonning eng qimmatli arxeologik yodgorligi"
                ],
                images: [toproqqala1, toproqqala2, toproqqala3,]
            },

            {
                title: "Mizdaxon nekropoli",

                content: `
Mizdaxon — Qoraqalpog‘istondagi eng qadimiy va ulkan qabristonlar majmuasi bo‘lib, 2500 yildan ortiq vaqt davomida ishlatib kelingan.

Bu yer nafaqat qabriston, balki qadimiy shahar va qal’a qoldiqlarini ham o‘z ichiga oladi.

Mizdaxon mahalliy afsonalarga ko‘ra dunyoning "markazlaridan biri" sifatida qadrlanadi va bugungi kunda ham ziyoratgoh hisoblanadi.
    `,

                details: `
Mizdaxon majmuasi miloddan avvalgi IV asrdan XIV asrgacha faol bo‘lgan bo‘lib, u bir necha tarixiy qatlamlarni o‘z ichiga oladi.

📌 Majmua tarkibi:
- Gyaur-qala — qadimiy shahar-qal’a qoldiqlari
- Nazlumxon-Tepasi — afsonaviy malika qabri joylashgan tepalik
- Xalqlar do‘stligi tepaligi — turli davr maqbaralari

📌 Afsonalar:
Mahalliy rivoyatlarga ko‘ra, Nazlumxon ismli malika bilan bog‘liq fojiali sevgi tarixi ushbu joyni afsonaviy maskanga aylantirgan.

📌 Tarixiy ahamiyati:
- Xorazm mintaqasining eng qadimgi qabristonlaridan biri
- Zardushtiylik va islom davri dafn marosimlari izlarini saqlaydi
- Arxeologik jihatdan bir necha ming yillik tarixni qamrab oladi

Mizdaxon bugungi kunda ham mahalliy aholi tomonidan muqaddas maskan sifatida ziyorat qilinadi.
    `,
                facts: [
                    "Xo‘jayli tumani yaqinida joylashgan",
                    "2500 yildan ortiq vaqt davomida ishlatilgan",
                    "Miloddan avvalgi IV asrdan mavjud",
                    "Gyaur-qala shahar-qal’a qoldiqlarini o‘z ichiga oladi",
                    "Nazlumxon-Tepasi afsonaviy malika qabri bilan bog‘liq",
                    "Turli davr maqbaralari saqlangan",
                    "Zardushtiylik va islom davri izlarini saqlaydi",
                    "Xorazmning eng qadimiy nekropollaridan biri",
                    "Mahalliy aholi tomonidan hozir ham ziyorat qilinadi",
                    "Arxeologik jihatdan bir necha ming yillikni qamrab oladi",
                    "Rivoyatlarga ko‘ra dunyoning \"markazlaridan biri\"",
                    "Qoraqalpog‘istonning muhim madaniy yodgorligi",
                    "Turli xalq va dinlarning dafn an’analarini aks ettiradi",
                    "Tadqiqotchilar uchun boy ilmiy manba",
                    "UNESCO ehtimoliy meros ro‘yxatiga taklif etilgan"
                ],
                images: [mizdaxon1, mizdaxon2, mizdaxon3,]
            },

            {
                title: "Savitskiy nomidagi san’at muzeyi",

                content: `
Savitskiy nomidagi Qoraqalpog‘iston davlat san’at muzeyi Nukus shahrida joylashgan bo‘lib, dunyodagi eng yirik rus avangard san’ati kolleksiyalaridan biriga ega.

Muzey rassom va arxeolog Igor Savitskiy tomonidan Sovet davrida taqiqlangan asarlarni yig‘ib, asrab qolish natijasida yaratilgan.

Bu muzey "cho‘l ichidagi Luvr" deb ham ataladi va jahon san’atshunosligida alohida o‘rin tutadi.
    `,

                details: `
Muzey 1966-yilda Igor Savitskiy tomonidan asos solingan.

📌 Kolleksiya haqida:
- 90 000 dan ortiq eksponat saqlanadi
- Sovet davrida rasman taqiqlangan avangard rassomlar asarlari
- Markaziy Osiyo amaliy san’ati namunalari
- Qadimiy arxeologik topilmalar ham saqlanadi

📌 Igor Savitskiy haqida:
Savitskiy 1950–1980-yillarda Sovet hukumati tomonidan man etilgan rassomlarning asarlarini xavf ostida yig‘ib, Nukusga olib kelgan va shu tariqa ularni yo‘q bo‘lib ketishdan saqlab qolgan.

📌 Ahamiyati:
Muzey nafaqat badiiy, balki tarixiy jihatdan ham noyob hisoblanadi — u Sovet davri rasmiy san’at siyosatiga qarshi turgan ijodkorlar merosini saqlagan yagona yirik markaz.

Bugungi kunda muzey zamonaviy binoda joylashgan bo‘lib, dunyoning turli burchaklaridan san’atshunoslarni o‘ziga jalb qilmoqda.
    `,
                facts: [
                    "Nukus shahrida joylashgan",
                    "1966-yilda Igor Savitskiy tomonidan asos solingan",
                    "90 000 dan ortiq eksponatga ega",
                    "Rus avangard san’atining yirik kolleksiyasi",
                    "\"Cho‘l ichidagi Luvr\" deb ham ataladi",
                    "Sovet davrida taqiqlangan rassomlar asarlarini saqlaydi",
                    "Markaziy Osiyo amaliy san’ati namunalari mavjud",
                    "Arxeologik topilmalar ham namoyish etiladi",
                    "Jahon san’atshunosligida alohida o‘rin tutadi",
                    "Zamonaviy muzey binosida joylashgan",
                    "Dunyoning turli davlatlaridan mehmonlarni jalb qiladi",
                    "San’at tarixi bo‘yicha noyob ilmiy manba",
                    "Savitskiy nomi bilan xalqaro miqyosda tanilgan",
                    "Qoraqalpog‘istonning madaniy ramzi hisoblanadi",
                    "Har yili maxsus ko‘rgazmalar tashkil etiladi"
                ],
                images: [savitskiy1, savitskiy2, savitskiy3,]
            },

            {
                title: "Chilpiq dahmasi",

                content: `
Chilpiq — Amudaryo bo‘yidagi baland tepalikda joylashgan qadimiy zardushtiy dahmasi bo‘lib, O‘zbekistondagi eng noyob va sirli yodgorliklardan biri hisoblanadi.

Bu inshoot zardushtiylik dinining marhumlarni dafn etish marosimlari bilan bog‘liq bo‘lib, doiraviy shaklga ega.

Chilpiq o‘zining g‘ayrioddiy shakli va tarixi bilan sayyohlar va tadqiqotchilar e’tiborini tortadi.
    `,

                details: `
Chilpiq dahmasi miloddan avvalgi I asr — milodiy I asrlarda qurilgan deb taxmin qilinadi.

📌 Zardushtiylik marosimi:
Zardushtiylik e’tiqodiga ko‘ra, marhum tanasi tuproq, suv yoki olovni ifloslantirmasligi kerak bo‘lgan. Shu sababli jasadlar bunday baland dahmalarga qo‘yilib, quyosh va qushlar ta’sirida tozalangan, so‘ngra suyaklar maxsus idishlarga (ossuariy) joylashtirilgan.

📌 Arxitektura:
- Doiraviy shaklda, tepalik ustiga qurilgan
- Balandligi atrofdagi tekislikdan taxminan 30 metr
- Ikki qavatli mudofaa-marosim devorlari

📌 Tarixiy ahamiyati:
- Markaziy Osiyoda saqlanib qolgan noyob zardushtiy dahmasi
- Qadimgi Xorazm dini va urf-odatlarini o‘rganishda muhim manba
- Astronomik kuzatuvlar uchun ham foydalanilgan degan taxminlar bor

Chilpiq bugungi kunda ham o‘zining sirli va sokin muhiti bilan ziyoratchilarni o‘ziga jalb qiladi.
    `,
                facts: [
                    "Amudaryo bo‘yida, Nukus yaqinida joylashgan",
                    "Miloddan avvalgi I asr atrofida qurilgan",
                    "Zardushtiylik dafn marosimlari uchun ishlatilgan",
                    "Doiraviy shaklga ega noyob inshoot",
                    "Tepalik balandligi atrofdan 30 metrga yaqin",
                    "Jasadlar quyosh va qushlar ta’sirida tozalangan",
                    "Suyaklar ossuariylarga joylashtirilgan",
                    "Markaziy Osiyodagi saqlangan noyob zardushtiy yodgorligi",
                    "Qadimgi Xorazm dini haqida muhim ma’lumot beradi",
                    "Astronomik kuzatuv nuqtasi bo‘lgan degan taxminlar bor",
                    "Sirli va sokin muhiti bilan mashhur",
                    "Sayyohlar va tadqiqotchilar tomonidan ziyorat qilinadi",
                    "Qoraqalpog‘istonning eng g‘ayrioddiy yodgorligi",
                    "Kunbotarda ajoyib manzara hosil qiladi",
                    "Zardushtiylik tarixini o‘rganishda kalit obyekt"
                ],
                images: [chilpiq1, chilpiq2, chilpiq3,]
            },

            {
                title: "Qo‘yqirilgan qala",

                content: `
Qo‘yqirilgan qala — Qoraqalpog‘istondagi yirik qadimiy shahar-qal’a bo‘lib, Kushon davrida Xorazm mintaqasining muhim markazlaridan biri hisoblangan.

Shahar dumaloq rejalashtirilgan bo‘lib, o‘z davrida rivojlangan shaharsozlik va mudofaa tizimiga ega bo‘lgan.

Qo‘yqirilgan qala Xorazm qadimiy shaharsozlik san’atini o‘rganishda muhim ahamiyatga ega.
    `,

                details: `
Qo‘yqirilgan qala miloddan avvalgi IV asr — milodiy IV asrlar oralig‘ida faol bo‘lgan.

📌 Shahar tuzilishi:
- Dumaloq rejalashtirilgan noyob shahar shakli
- Ikki qatorli mudofaa devorlari
- Markaziy qismda hukmdor saroyi joylashgan bo‘lgan
- Atrofida turar-joy va hunarmandchilik hududlari

📌 Topilmalar:
- Kushon davri tangalari
- Kulolchilik va metall buyumlar
- Mudofaa qurollari qoldiqlari

📌 Tarixiy ahamiyati:
- Xorazm shaharsozligining rivojlangan bosqichini ko‘rsatadi
- Kushon imperiyasi bilan savdo-madaniy aloqalarni tasdiqlaydi
- Mintaqadagi qadimgi shaharlar tizimining muhim bo‘g‘ini

Bugungi kunda shahar xarobalari saqlanib qolgan bo‘lib, arxeologik tadqiqotlar davom etmoqda.
    `,
                facts: [
                    "Qoraqalpog‘iston hududida joylashgan",
                    "Miloddan avvalgi IV — milodiy IV asrlarda faol bo‘lgan",
                    "Dumaloq rejalashtirilgan noyob shahar shakliga ega",
                    "Ikki qatorli mudofaa devorlari saqlangan",
                    "Markazida hukmdor saroyi bo‘lgan",
                    "Kushon davri tangalari topilgan",
                    "Kulolchilik va metall buyumlar aniqlangan",
                    "Xorazm shaharsozligi taraqqiyotini ko‘rsatadi",
                    "Kushon imperiyasi bilan aloqalarni tasdiqlaydi",
                    "\"Ellik qal’a\" tizimining muhim a’zosi",
                    "Arxeologik tadqiqotlar hozir ham davom etmoqda",
                    "Qadimgi shaharsozlik san’atining namunasi",
                    "Mintaqaning mudofaa tizimini o‘rganishda muhim",
                    "Tarixchilar uchun qimmatli ilmiy manba",
                    "Qoraqalpog‘istonning kam tanilgan, ammo qimmatli yodgorligi"
                ],
                images: [qoyqirilgan1, qoyqirilgan2, qoyqirilgan3,]
            }
        ]
    },

    ru: {
        key: "qoraqalpogiston",
        title: "Каракалпакстан — край древних крепостей среди пустынь",

        intro: `
Республика Каракалпакстан — уникальный регион, расположенный в нижнем течении Амударьи, между пустыней Кызылкум и плато Устюрт.

Этот край известен древними хорезмийскими крепостями, которые называют «Эллик-кала» («Пятьдесят крепостей»), а также всемирно известным музеем искусства имени Игоря Савицкого.
`,

        history: `
Территория Каракалпакстана в древности была частью Хорезмийской цивилизации, история которой насчитывает более двух с половиной тысяч лет. Благодаря своему расположению в нижнем течении Амударьи этот регион имел важное оборонительное и культурное значение в государстве Хорезмшахов.

Регион известен под названием «Эллик-кала», где были построены сотни древних крепостей и оборонительных сооружений. Эти крепости защищали Хорезмскую оазисную цивилизацию от нападений кочевых племён.

В IV–I веках до нашей эры здесь существовали развитые государственные образования. Позже регион процветал в эпоху Кушанского царства и династии Афригидов. Зороастризм был широко распространён в этих землях, а такие сооружения, как Чильпик, являются свидетельствами той эпохи.

В Средние века из-за монгольского нашествия и изменения русла Амударьи многие древние города были покинуты и постепенно погребены под песками пустыни.

В XX веке Каракалпакстан стал известен не только благодаря своему богатому археологическому наследию, но и благодаря уникальной коллекции авангардного искусства, собранной Игорем Савицким.

Сегодня регион считается «краем крепостей в пустыне» и является одним из самых загадочных и необычных уголков Узбекистана для туристов и исследователей истории.
`,

        sections: [
            {
                title: "Древняя крепость Аяз-Кала",

                content: `
Аяз-Кала — одна из самых известных и хорошо сохранившихся древних крепостей Каракалпакстана, расположенная на высокой возвышенности среди пустыни Кызылкум.

Этот комплекс состоит из трёх частей и включает оборонительные и жилые сооружения разных исторических периодов.

Аяз-Кала считается одним из самых впечатляющих памятников Каракалпакстана благодаря своим огромным крепостным стенам и уникальному пустынному пейзажу вокруг.
`,

                details: `
Комплекс Аяз-Кала состоит из трёх отдельных крепостей, построенных в разные исторические периоды.

📌 Состав комплекса:
- Аяз-Кала 1 — военная крепость IV–III веков до нашей эры
- Аяз-Кала 2 — феодальный замок-крепость IV–VI веков
- Аяз-Кала 3 — жилой комплекс VII–VIII веков

📌 Архитектурные особенности:
- Толстые оборонительные стены из сырцового кирпича
- Башни и наблюдательные площадки
- Стратегическое расположение на высокой возвышенности

📌 Историческое значение:
- Защищала Хорезмский оазис от нападений кочевых племён
- Является примером древней военной архитектуры Хорезма
- Была важной частью системы оборонительных крепостей региона

Сегодня рядом с Аяз-Калой создан туристический комплекс с традиционными юртами, где путешественники могут остановиться и познакомиться с культурой региона.
`,

                facts: [
                    "Расположена примерно в 90 км от города Нукус",
                    "Состоит из трёх отдельных крепостей",
                    "Самая древняя часть относится к IV веку до нашей эры",
                    "Сохранились оборонительные стены из сырцового кирпича",
                    "Является примером военной архитектуры Хорезма",
                    "Расположена на высокой стратегической возвышенности",
                    "Использовалась для защиты от нападений кочевников",
                    "Рядом создан туристический юрточный лагерь",
                    "Известна красивыми пейзажами пустыни Кызылкум",
                    "Одна из самых посещаемых крепостей Каракалпакстана",
                    "Хорошо сохранившийся археологический объект",
                    "Часть древней оборонительной системы Хорезма",
                    "Особенно впечатляюще выглядит во время заката",
                    "Популярное место среди фотографов",
                    "Самый известный объект системы «Эллик-кала»"
                ],

                images: [ayozqala1, ayozqala2, ayozqala3,]
            },
            {
                title: "Древний город Топрак-Кала",

                content: `
Топрак-Кала — это руины древнего города, который был столицей государства Хорезм и является одним из важнейших археологических памятников региона.

Обнаруженный здесь дворцовый комплекс и уникальные находки свидетельствуют о высоком уровне развития Хорезмской цивилизации.

Археологи также называют Топрак-Калу «Помпеями пустыни», поскольку город сохранился в удивительно хорошем состоянии.
`,

                details: `
Топрак-Кала процветал в I–IV веках и служил столицей Хорезмского государства.

📌 Дворцовый комплекс:
- Огромный трёхэтажный дворец
- Специальные помещения, такие как «Зал царей» и «Зал танцовщиц»
- Сохранившиеся цветные настенные росписи и скульптуры

📌 Важные находки:
- Документы, написанные на древнехорезмийском языке
- Скульптуры царей и цариц
- Предметы повседневной жизни древних жителей

📌 Историческое значение:
- Был центром древнего Хорезмского государства
- Здесь обнаружены находки, связанные с зороастризмом
- Является уникальным источником для изучения истории Центральной Азии

После IV века город потерял статус столицы и постепенно был заброшен, однако его остатки сохранились до наших дней в очень хорошем состоянии.
`,

                facts: [
                    "Расположен на территории Берунийского района",
                    "Был столицей Хорезма в I–IV веках",
                    "Известен как «Помпеи пустыни»",
                    "Обнаружен трёхэтажный дворцовый комплекс",
                    "Сохранились цветные настенные росписи",
                    "Найдены образцы древнехорезмийской письменности",
                    "Обнаружены скульптуры царей и цариц",
                    "Найдены предметы, связанные с зороастризмом",
                    "Важный источник по древней истории Центральной Азии",
                    "Археологические раскопки начались в середине XX века",
                    "Находки хранятся в музеях Нукуса и Ташкента",
                    "Был политическим и культурным центром Хорезма",
                    "После IV века постепенно был заброшен",
                    "Отличается высокой степенью сохранности",
                    "Один из самых ценных археологических памятников Каракалпакстана"
                ],

                images: [toproqqala1, toproqqala2, toproqqala3,]
            },
            {
                title: "Некрополь Миздахан",

                content: `
Миздахан — один из самых древних и крупных некрополей Каракалпакстана, который использовался на протяжении более 2500 лет.

Это место является не только кладбищенским комплексом, но также включает остатки древнего города и крепости.

Согласно местным легендам, Миздахан считается одним из «центров мира» и до сегодняшнего дня остаётся важным местом паломничества.
`,

                details: `
Комплекс Миздахан существовал с IV века до нашей эры до XIV века и включает несколько исторических слоёв разных эпох.

📌 Состав комплекса:
- Гяур-Кала — остатки древнего города-крепости
- Назлумхан-Тепе — холм, связанный с легендарной могилой принцессы
- Холм Дружбы народов — захоронения разных исторических периодов

📌 Легенды:
Согласно местным преданиям, трагическая история любви принцессы по имени Назлумхан сделала это место загадочным и священным.

📌 Историческое значение:
- Один из древнейших некрополей Хорезмского региона
- Сохраняет следы погребальных традиций зороастризма и исламского периода
- Охватывает несколько тысяч лет археологической истории

Сегодня Миздахан по-прежнему считается священным местом и посещается местными жителями и паломниками.
`,

                facts: [
                    "Расположен недалеко от Ходжейлийского района",
                    "Использовался более 2500 лет",
                    "Существует с IV века до нашей эры",
                    "Включает остатки древнего города-крепости Гяур-Кала",
                    "Назлумхан-Тепе связано с легендой о принцессе",
                    "Сохраняет мавзолеи разных исторических периодов",
                    "Содержит следы зороастрийских и исламских традиций захоронения",
                    "Один из древнейших некрополей Хорезма",
                    "До сих пор посещается местными жителями",
                    "Охватывает несколько тысяч лет археологической истории",
                    "Согласно легендам, является одним из «центров мира»",
                    "Важный культурный памятник Каракалпакстана",
                    "Отражает погребальные традиции разных народов и эпох",
                    "Ценный научный источник для исследователей",
                    "Предлагался для включения в предварительный список наследия ЮНЕСКО"
                ],

                images: [mizdaxon1, mizdaxon2, mizdaxon3,]
            },
            {
                title: "Музей искусств имени Савицкого",

                content: `
Государственный музей искусств Каракалпакстана имени Савицкого расположен в городе Нукус и обладает одной из крупнейших в мире коллекций русского авангардного искусства.

Музей был создан благодаря художнику и археологу Игорю Савицкому, который в советский период собирал и сохранял произведения искусства, запрещённые официальной властью.

Этот музей также называют «Лувром в пустыне», и он занимает особое место в мировом искусствоведении.
`,

                details: `
Музей был основан в 1966 году Игорем Савицким.

📌 О коллекции:
- В музее хранится более 90 000 экспонатов
- Произведения художников-авангардистов, запрещённых в советское время
- Образцы прикладного искусства Центральной Азии
- Древние археологические находки

📌 Об Игоре Савицком:
В 1950–1980-х годах Савицкий собирал произведения художников, которые подвергались запретам со стороны советской власти. Он привозил их в Нукус и таким образом спас многие уникальные работы от исчезновения.

📌 Значение:
Музей является уникальным не только с художественной, но и с исторической точки зрения — он сохранил наследие художников, которые оказались вне официальной советской художественной политики.

Сегодня музей расположен в современном здании и привлекает искусствоведов и туристов со всего мира.
`,

                facts: [
                    "Расположен в городе Нукус",
                    "Основан в 1966 году Игорем Савицким",
                    "Хранит более 90 000 экспонатов",
                    "Обладает одной из крупнейших коллекций русского авангарда",
                    "Известен как «Лувр в пустыне»",
                    "Сохраняет произведения художников, запрещённых в советский период",
                    "В коллекции представлены образцы искусства Центральной Азии",
                    "В музее хранятся археологические находки",
                    "Имеет особое значение в мировом искусствоведении",
                    "Расположен в современном музейном здании",
                    "Привлекает посетителей со всего мира",
                    "Является уникальным научным источником по истории искусства",
                    "Имя Савицкого известно на международном уровне",
                    "Считается культурным символом Каракалпакстана",
                    "Ежегодно здесь проводятся специальные выставки"
                ],

                images: [savitskiy1, savitskiy2, savitskiy3,]
            },
            {
                title: "Чильпикская дахма",

                content: `
Чильпик — древняя зороастрийская дахма, расположенная на высокой возвышенности у берегов Амударьи. Это один из самых уникальных и загадочных памятников Узбекистана.

Сооружение связано с древними погребальными традициями зороастризма и имеет характерную круглую форму.

Чильпик привлекает внимание туристов и исследователей своей необычной архитектурой, историей и таинственной атмосферой.
`,

                details: `
Считается, что Чильпикская дахма была построена примерно в I веке до нашей эры — I веке нашей эры.

📌 Зороастрийский обряд:
Согласно верованиям зороастрийцев, тело умершего не должно было осквернять землю, воду или огонь. Поэтому тела помещали на такие высокие дахмы, где они очищались под воздействием солнца и птиц, а затем кости складывали в специальные сосуды — оссуарии.

📌 Архитектура:
- Круглая форма, построенная на вершине холма
- Высота холма составляет около 30 метров над окружающей равниной
- Двойные стены, выполнявшие защитную и ритуальную функции

📌 Историческое значение:
- Один из редких сохранившихся зороастрийских памятников Центральной Азии
- Важный источник для изучения религии и традиций древнего Хорезма
- Существует предположение, что место могло использоваться также для астрономических наблюдений

Сегодня Чильпик продолжает привлекать посетителей своей загадочной атмосферой, тишиной и древней историей.
`,

                facts: [
                    "Расположен у берегов Амударьи недалеко от Нукуса",
                    "Построен примерно в I веке до нашей эры",
                    "Использовался в зороастрийских погребальных обрядах",
                    "Имеет уникальную круглую форму",
                    "Высота холма составляет около 30 метров",
                    "Тела умерших очищались под воздействием солнца и птиц",
                    "Кости помещались в специальные сосуды — оссуарии",
                    "Один из немногих сохранившихся зороастрийских памятников Центральной Азии",
                    "Даёт важные сведения о религии древнего Хорезма",
                    "Существует версия об использовании для астрономических наблюдений",
                    "Известен своей загадочной и спокойной атмосферой",
                    "Посещается туристами и исследователями",
                    "Один из самых необычных памятников Каракалпакстана",
                    "Особенно красив во время заката",
                    "Важный объект для изучения истории зороастризма"
                ],

                images: [chilpiq1, chilpiq2, chilpiq3,]
            },
            {
                title: "Кой-Крылган-Кала",

                content: `
Кой-Крылган-Кала — крупный древний город-крепость Каракалпакстана, который в кушанский период являлся одним из важных центров Хорезмского региона.

Город имел круглую планировку и обладал развитой системой градостроительства и обороны для своего времени.

Кой-Крылган-Кала имеет большое значение для изучения древнего градостроительного искусства Хорезма.
`,

                details: `
Кой-Крылган-Кала существовала с IV века до нашей эры до IV века нашей эры.

📌 Структура города:
- Уникальная круглая планировка древнего города
- Двойная система оборонительных стен
- В центральной части располагался дворец правителя
- Вокруг находились жилые кварталы и ремесленные зоны

📌 Археологические находки:
- Монеты кушанского периода
- Керамические и металлические изделия
- Остатки военного снаряжения

📌 Историческое значение:
- Показывает высокий уровень развития древнего градостроительства Хорезма
- Подтверждает торговые и культурные связи с Кушанской империей
- Является важной частью системы древних городов региона

Сегодня руины города сохранились, а археологические исследования продолжаются.
`,

                facts: [
                    "Расположен на территории Каракалпакстана",
                    "Существовал с IV века до нашей эры до IV века нашей эры",
                    "Имеет уникальную круглую планировку",
                    "Сохранились двойные оборонительные стены",
                    "В центре находился дворец правителя",
                    "Обнаружены монеты кушанского периода",
                    "Найдены керамические и металлические изделия",
                    "Отражает развитие древней городской культуры Хорезма",
                    "Подтверждает связи с Кушанской империей",
                    "Является важной частью системы «Эллик-Кала»",
                    "Археологические исследования продолжаются до сих пор",
                    "Пример древнего градостроительного искусства",
                    "Важный объект для изучения оборонительной системы региона",
                    "Ценный научный источник для историков",
                    "Малоизвестный, но ценный памятник Каракалпакстана"
                ],

                images: [qoyqirilgan1, qoyqirilgan2, qoyqirilgan3,]
            }
        ]
    },

    en: {
        key: "qoraqalpogiston",
        title: "Karakalpakstan — The Land of Ancient Fortresses in the Desert",

        intro: `
The Republic of Karakalpakstan is a unique region located in the lower reaches of the Amu Darya River, between the Kyzylkum Desert and the Ustyurt Plateau.

The region is famous for its ancient Khorezm fortresses, known as "Ellik Qala" (Fifty Fortresses), as well as the world-famous Savitsky Museum of Art in Nukus.
`,

        history: `
The territory of Karakalpakstan was once part of the ancient Khorezm civilization, with a history dating back to the 7th–6th centuries BC. Located in the lower Amu Darya region, it played an important role as a cultural and defensive area of the Khorezm state.

The region is famous for the "Ellik Qala" fortress system, where hundreds of ancient fortresses and defensive structures were built to protect the Khorezm oasis from invasions of nomadic tribes.

From the 4th to the 1st centuries BC, powerful states existed in this area. Later, during the Kushan Empire and the Afrighid dynasty, the region continued to develop. Zoroastrianism was widely practiced here, and monuments such as Chilpik Dakhma have survived from that period.

During the Middle Ages, the Mongol invasion and changes in the course of the Amu Darya caused many ancient cities to be abandoned and gradually buried under the sands of the desert.

In the 20th century, Karakalpakstan became internationally known not only for its rich archaeological heritage but also for the unique collection of avant-garde art gathered by Igor Savitsky.

Today, the region is known as "the land of fortresses in the desert" and remains one of the most mysterious and unique destinations in Uzbekistan for travelers and historians.
`,
        sections: [
            {
                title: "Ayaz-Kala Ancient Fortress",

                content: `
Ayaz-Kala is one of the most famous and well-preserved ancient fortresses in Karakalpakstan, located on a high hill in the middle of the Kyzylkum Desert.

The complex consists of three separate fortresses built in different historical periods, representing ancient defensive architecture and settlement traditions.

With its massive walls and breathtaking desert landscape, Ayaz-Kala is considered one of the most impressive historical monuments of Karakalpakstan.
`,

                details: `
The Ayaz-Kala complex consists of three fortresses that were built during different periods of ancient Khorezm history.

📌 Structure of the complex:
- Ayaz-Kala 1 — a military fortress dating back to the 4th–3rd centuries BC
- Ayaz-Kala 2 — a feudal castle fortress from the 4th–6th centuries AD
- Ayaz-Kala 3 — a residential complex from the 7th–8th centuries AD

📌 Architectural features:
- Thick defensive walls made of mud bricks
- Towers and observation points
- Strategic location on a high hill overlooking the desert

📌 Historical importance:
- Protected the Khorezm oasis from attacks by nomadic tribes
- Represents ancient Khorezm military architecture
- Was an important part of the defensive fortress system of the region

Today, a traditional yurt camp has been established near Ayaz-Kala, allowing visitors to experience the desert atmosphere and spend the night in traditional surroundings.
`,

                facts: [
                    "Located about 90 km from Nukus",
                    "Consists of three separate fortresses",
                    "The oldest part dates back to the 4th century BC",
                    "Built mainly from mud bricks",
                    "An example of ancient Khorezm military architecture",
                    "Located on a strategically important hill",
                    "Served as protection against nomadic invasions",
                    "A tourist yurt camp is located nearby",
                    "Famous for its Kyzylkum Desert views",
                    "One of the most visited fortresses in Karakalpakstan",
                    "Well-preserved archaeological monument",
                    "Part of the ancient Khorezm defensive system",
                    "Offers spectacular sunset views",
                    "Popular location among photographers",
                    "One of the most famous monuments of the Ellik Qala fortress system"
                ],

                images: [ayozqala1, ayozqala2, ayozqala3,]
            },
            {
                title: "Toprak-Kala Ancient City",

                content: `
Toprak-Kala is a large ancient city ruin that served as the capital of the ancient Khorezm state and is considered one of the most important archaeological sites in the region.

The palace complex and unique discoveries found here demonstrate the high level of development of Khorezm civilization.

Toprak-Kala is often called the "Pompeii of the Desert" because of its remarkable preservation.
`,

                details: `
Toprak-Kala flourished between the 1st and 4th centuries AD and served as the royal capital of ancient Khorezm.

📌 Palace complex:
- A massive three-story royal palace
- Special halls such as the "Hall of Kings" and the "Hall of Dancers"
- Colorful wall paintings and sculptures that have survived to the present day

📌 Important discoveries:
- Documents written in the ancient Khorezm language
- Sculptures depicting kings and queens
- Everyday objects from ancient life

📌 Historical importance:
- Was the political center of the ancient Khorezm state
- Contains discoveries connected with Zoroastrian traditions
- Provides valuable information for studying the history of Central Asia

After the 4th century AD, the city gradually lost its status as a capital and was eventually abandoned, but its remains have been remarkably preserved.
`,

                facts: [
                    "Located in Beruni district",
                    "Was the capital of Khorezm during the 1st–4th centuries AD",
                    "Known as the 'Pompeii of the Desert'",
                    "Contains the remains of a three-story palace complex",
                    "Ancient colorful wall paintings have been preserved",
                    "Examples of Khorezm writing were discovered here",
                    "Sculptures of kings and queens were found",
                    "Contains artifacts related to Zoroastrianism",
                    "An important source for the ancient history of Central Asia",
                    "Archaeological excavations began in the middle of the 20th century",
                    "Artifacts are preserved in museums of Nukus and Tashkent",
                    "Was the center of ancient Khorezm statehood",
                    "Was gradually abandoned after the 4th century",
                    "Remarkably well-preserved archaeological site",
                    "One of the most valuable historical monuments of Karakalpakstan"
                ],

                images: [toproqqala1, toproqqala2, toproqqala3,]
            },
            {
                title: "Mizdakhan Necropolis",

                content: `
Mizdakhan is one of the oldest and largest cemetery complexes in Karakalpakstan, which has been used for more than 2,500 years.

The site includes not only ancient burial grounds but also the remains of an old city and fortress.

According to local legends, Mizdakhan is considered one of the sacred centers of the world and remains an important pilgrimage site today.
`,

                details: `
The Mizdakhan complex was active from the 4th century BC to the 14th century AD and contains several layers of different historical periods.

📌 Structure of the complex:
- Gyaur-Kala — remains of an ancient city and fortress
- Nazlumkhan Hill — associated with the legendary tomb of a princess
- Hill of Friendship of Peoples — containing mausoleums from different periods

📌 Legends:
According to local traditions, the tragic love story connected with Princess Nazlumkhan turned this place into a legendary and mysterious destination.

📌 Historical importance:
- One of the oldest necropolises of the Khorezm region
- Preserves traces of both Zoroastrian and Islamic burial traditions
- Covers several thousand years of archaeological history

Today, Mizdakhan is still visited by local people as a sacred and historical place.
`,

                facts: [
                    "Located near Khojayli district",
                    "Has been used for more than 2,500 years",
                    "Dates back to the 4th century BC",
                    "Includes the remains of the ancient Gyaur-Kala city",
                    "Nazlumkhan Hill is connected with a legendary princess",
                    "Contains mausoleums from different historical periods",
                    "Preserves traces of Zoroastrian and Islamic traditions",
                    "One of the oldest necropolises of Khorezm",
                    "Still visited as a sacred place",
                    "Covers several thousand years of history",
                    "According to legends, it is one of the world's sacred centers",
                    "An important cultural monument of Karakalpakstan",
                    "Reflects burial traditions of different peoples and religions",
                    "A valuable source for researchers and historians",
                    "Proposed as a potential UNESCO World Heritage site"
                ],

                images: [mizdaxon1, mizdaxon2, mizdaxon3,]
            },
            {
                title: "Savitsky Museum of Art",

                content: `
The Karakalpakstan State Museum of Art named after Savitsky is located in Nukus and contains one of the world's largest collections of Russian avant-garde art.

The museum was created by artist and archaeologist Igor Savitsky, who collected and preserved artworks that were restricted and forgotten during the Soviet period.

Known as the "Louvre in the Desert", the museum holds a unique place in the world of art history.
`,

                details: `
The museum was founded in 1966 by Igor Savitsky.

📌 About the collection:
- More than 90,000 exhibits are preserved
- A rare collection of Russian avant-garde artworks
- Examples of Central Asian decorative and applied arts
- Ancient archaeological artifacts are also displayed

📌 About Igor Savitsky:
During the 1950s–1980s, Savitsky secretly collected works of artists who were rejected by Soviet official art policies. By bringing these artworks to Nukus, he saved many masterpieces from destruction and disappearance.

📌 Historical importance:
The museum is valuable not only as an art institution but also as a historical center that preserved the heritage of artists who were ignored during the Soviet era.

Today, the museum is located in a modern building and attracts art historians, researchers, and visitors from around the world.
`,

                facts: [
                    "Located in Nukus city",
                    "Founded in 1966 by Igor Savitsky",
                    "Contains more than 90,000 exhibits",
                    "One of the largest collections of Russian avant-garde art",
                    "Known as the 'Louvre in the Desert'",
                    "Preserves artworks banned during the Soviet period",
                    "Contains examples of Central Asian applied arts",
                    "Displays archaeological discoveries",
                    "Has international importance in art history",
                    "Located in a modern museum building",
                    "Attracts visitors from many countries",
                    "A valuable source for studying art history",
                    "Known worldwide under the name of Savitsky",
                    "A cultural symbol of Karakalpakstan",
                    "Hosts special exhibitions every year"
                ],

                images: [savitskiy1, savitskiy2, savitskiy3,]
            },
            {
                title: "Chilpik Dakhma",

                content: `
Chilpik is an ancient Zoroastrian dakhma located on a high hill near the Amu Darya River and is considered one of the most unique and mysterious monuments of Uzbekistan.

This circular structure is connected with Zoroastrian funeral traditions, where the bodies of the dead were placed according to ancient religious customs.

With its unusual shape and fascinating history, Chilpik attracts tourists and researchers from around the world.
`,

                details: `
Chilpik Dakhma is believed to have been built around the 1st century BC – 1st century AD.

📌 Zoroastrian tradition:
According to Zoroastrian beliefs, the body of a deceased person should not pollute the earth, water, or fire. Therefore, bodies were placed on elevated dakhmas where they were exposed to sunlight and birds. Later, the bones were collected and placed into special containers called ossuaries.

📌 Architecture:
- Circular structure built on top of a hill
- Located about 30 meters above the surrounding plain
- Features ancient ritual and protective walls

📌 Historical importance:
- One of the rare preserved Zoroastrian monuments in Central Asia
- Important source for studying ancient Khorezm religion and traditions
- Some researchers suggest it may have also been used for astronomical observations

Today, Chilpik continues to attract visitors with its mysterious atmosphere and impressive views of the surrounding landscape.
`,

                facts: [
                    "Located near Nukus, on the banks of the Amu Darya",
                    "Built around the 1st century BC",
                    "Used for Zoroastrian funeral rituals",
                    "Has a unique circular structure",
                    "The hill rises about 30 meters above the surrounding area",
                    "Bodies were exposed to sunlight and birds according to traditions",
                    "Bones were placed in special ossuaries",
                    "One of the best-preserved Zoroastrian monuments in Central Asia",
                    "Provides important information about ancient Khorezm religion",
                    "May have been used for astronomical observations",
                    "Famous for its mysterious and peaceful atmosphere",
                    "Visited by tourists and researchers",
                    "One of the most unusual monuments of Karakalpakstan",
                    "Creates a beautiful landscape during sunset",
                    "A key site for studying Zoroastrian history"
                ],

                images: [chilpiq1, chilpiq2, chilpiq3,]
            },
            {
                title: "Koykrylgan Kala Ancient Fortress",

                content: `
Koykrylgan Kala is a large ancient city-fortress in Karakalpakstan that was one of the important centers of the Khorezm region during the Kushan period.

The city had a unique circular layout and developed urban planning and defensive systems for its time.

Koykrylgan Kala plays an important role in studying the ancient urban culture and architectural traditions of Khorezm.
`,

                details: `
Koykrylgan Kala was active from the 4th century BC to the 4th century AD.

📌 City structure:
- A unique circular city layout
- Double defensive walls surrounding the settlement
- A ruler's palace located in the central part
- Residential and craft areas around the fortress

📌 Archaeological discoveries:
- Coins from the Kushan period
- Ceramic and metal objects
- Remains of ancient weapons and military equipment

📌 Historical importance:
- Demonstrates the advanced level of ancient Khorezm urban planning
- Confirms trade and cultural connections with the Kushan Empire
- Was an important part of the ancient city system of the region

Today, the ruins of Koykrylgan Kala are preserved, and archaeological research continues at the site.
`,

                facts: [
                    "Located in the territory of Karakalpakstan",
                    "Existed from the 4th century BC to the 4th century AD",
                    "Has a unique circular city design",
                    "Double defensive walls have been preserved",
                    "A ruler's palace was located in the center",
                    "Kushan period coins were discovered",
                    "Ceramic and metal artifacts were found",
                    "Shows the development of Khorezm urban culture",
                    "Confirms connections with the Kushan Empire",
                    "Was an important part of the Ellik Qala fortress system",
                    "Archaeological studies are still ongoing",
                    "An example of ancient city planning",
                    "Important for studying regional defense systems",
                    "A valuable scientific source for historians",
                    "A lesser-known but valuable monument of Karakalpakstan"
                ],

                images: [qoyqirilgan1, qoyqirilgan2, qoyqirilgan3,]
            }
        ]
    },

    fr: {
        key: "qoraqalpogiston",
        title: "Le Karakalpakstan — le pays des anciennes forteresses du désert",

        intro: `
La République du Karakalpakstan est une région unique située dans la partie inférieure de l’Amou-Daria, entre le désert du Kyzylkoum et le plateau d’Oust-Ourt.

Cette région est célèbre pour ses anciennes forteresses du Khorezm, connues sous le nom d’« Ellik Qala » (« Cinquante forteresses »), ainsi que pour le célèbre musée d’art Savitsky à Noukous.
`,

        history: `
Le territoire du Karakalpakstan faisait autrefois partie de l’ancienne civilisation du Khorezm, dont l’histoire remonte aux VIIe–VIe siècles avant notre ère. Située dans la basse vallée de l’Amou-Daria, cette région occupait une place importante dans la défense et la culture de l’État du Khorezm.

La région est connue pour le système de forteresses « Ellik Qala », où des centaines d’anciennes forteresses et constructions défensives ont été édifiées pour protéger l’oasis du Khorezm contre les attaques des tribus nomades.

Entre le IVe et le Ier siècle avant notre ère, plusieurs structures étatiques puissantes existaient dans cette région. Plus tard, durant l’Empire kouchan et la dynastie des Afrighides, le territoire a continué à prospérer. Le zoroastrisme y était largement pratiqué, et des monuments comme la Dakhma de Chilpik témoignent encore de cette époque.

Au Moyen Âge, les invasions mongoles et les changements du cours de l’Amou-Daria ont provoqué l’abandon de nombreuses villes anciennes, progressivement ensevelies sous les sables du désert.

Au XXe siècle, le Karakalpakstan est devenu célèbre non seulement pour son riche patrimoine archéologique, mais aussi pour la collection exceptionnelle d’art d’avant-garde réunie par Igor Savitsky.

Aujourd’hui, la région est appelée « le pays des forteresses dans le désert » et représente l’une des destinations les plus mystérieuses et originales d’Ouzbékistan pour les voyageurs et les passionnés d’histoire.
`,

        sections: [
            {
                title: "Ancienne forteresse d’Ayaz-Kala",

                content: `
Ayaz-Kala est l’une des forteresses anciennes les plus célèbres et les mieux conservées du Karakalpakstan. Elle est située sur une haute colline au milieu du désert du Kyzylkoum.

Ce complexe se compose de trois forteresses distinctes construites à différentes périodes historiques, représentant l’architecture défensive et les traditions urbaines de l’ancien Khorezm.

Avec ses immenses murailles et son paysage désertique spectaculaire, Ayaz-Kala est considérée comme l’un des monuments historiques les plus impressionnants du Karakalpakstan.
`,

                details: `
Le complexe d’Ayaz-Kala comprend trois forteresses construites à différentes périodes de l’histoire du Khorezm.

📌 Composition du complexe :
- Ayaz-Kala 1 — une forteresse militaire datant des IVe–IIIe siècles avant notre ère
- Ayaz-Kala 2 — un château-forteresse féodal des IVe–VIe siècles
- Ayaz-Kala 3 — un complexe résidentiel datant des VIIe–VIIIe siècles

📌 Caractéristiques architecturales :
- Épaisses murailles défensives construites en briques de terre crue
- Tours et postes d’observation
- Position stratégique au sommet d’une colline dominant le désert

📌 Importance historique :
- Protégeait l’oasis du Khorezm contre les attaques des tribus nomades
- Représente un exemple remarquable de l’architecture militaire antique du Khorezm
- Faisait partie du système de fortifications de la région

Aujourd’hui, un camp touristique de yourtes a été installé près d’Ayaz-Kala, permettant aux visiteurs de découvrir l’atmosphère du désert et de séjourner dans un environnement traditionnel.
`,

                facts: [
                    "Située à environ 90 km de Noukous",
                    "Composée de trois forteresses distinctes",
                    "La partie la plus ancienne date du IVe siècle avant notre ère",
                    "Construite principalement en briques de terre crue",
                    "Exemple remarquable de l’architecture militaire du Khorezm",
                    "Située sur une colline stratégique",
                    "Servait à protéger la région contre les invasions nomades",
                    "Un camp touristique de yourtes se trouve à proximité",
                    "Célèbre pour les paysages du désert du Kyzylkoum",
                    "L’une des forteresses les plus visitées du Karakalpakstan",
                    "Un site archéologique bien conservé",
                    "Une partie du système défensif antique du Khorezm",
                    "Offre un paysage magnifique au coucher du soleil",
                    "Un lieu apprécié par les photographes",
                    "L’un des monuments les plus célèbres du système « Ellik Qala »"
                ],

                images: [ayozqala1, ayozqala2, ayozqala3,]
            },
            {
                title: "Ancienne ville de Toprak-Kala",

                content: `
Toprak-Kala est une vaste cité antique qui fut la capitale de l’ancien État du Khorezm et qui représente l’un des sites archéologiques les plus importants de la région.

Le complexe du palais ainsi que les découvertes exceptionnelles réalisées sur place témoignent du haut niveau de développement de la civilisation khorézmienne.

Toprak-Kala est également surnommée la « Pompéi du désert » en raison de son état remarquable de conservation.
`,

                details: `
Toprak-Kala a prospéré entre le Ier et le IVe siècle de notre ère et a servi de capitale royale de l’ancien Khorezm.

📌 Complexe du palais :
- Un immense palais royal à trois niveaux
- Des salles spéciales comme la « Salle des rois » et la « Salle des danseuses »
- Des peintures murales colorées et des sculptures conservées jusqu’à aujourd’hui

📌 Découvertes importantes :
- Des documents écrits en langue khorézmienne ancienne
- Des sculptures représentant des rois et des reines
- Des objets de la vie quotidienne des habitants anciens

📌 Importance historique :
- Était le centre politique de l’ancien État du Khorezm
- Contient des découvertes liées aux traditions zoroastriennes
- Constitue une source exceptionnelle pour l’étude de l’histoire de l’Asie centrale

Après le IVe siècle, la ville a progressivement perdu son statut de capitale et a été abandonnée, mais ses vestiges restent remarquablement bien conservés.
`,

                facts: [
                    "Située dans le district de Beruni",
                    "Capitale du Khorezm entre le Ier et le IVe siècle",
                    "Surnommée la « Pompéi du désert »",
                    "Comprend les vestiges d’un palais royal à trois niveaux",
                    "Des peintures murales colorées ont été conservées",
                    "Des exemples d’écriture khorézmienne ancienne ont été découverts",
                    "Des sculptures de rois et de reines ont été retrouvées",
                    "Des objets liés au zoroastrisme ont été découverts",
                    "Une source importante pour l’histoire ancienne de l’Asie centrale",
                    "Les fouilles archéologiques ont commencé au XXe siècle",
                    "Les objets découverts sont conservés dans les musées de Noukous et Tachkent",
                    "Était le centre politique et culturel du Khorezm antique",
                    "A été progressivement abandonnée après le IVe siècle",
                    "Remarquablement bien conservée par rapport à d’autres sites antiques",
                    "L’un des monuments archéologiques les plus précieux du Karakalpakstan"
                ],

                images: [toproqqala1, toproqqala2, toproqqala3,]
            },
            {
                title: "Nécropole de Mizdakhan",

                content: `
Mizdakhan est l’un des plus anciens et des plus grands complexes funéraires du Karakalpakstan, utilisé depuis plus de 2 500 ans.

Ce site ne comprend pas seulement une nécropole, mais également les vestiges d’une ancienne ville et d’une forteresse.

Selon les légendes locales, Mizdakhan est considéré comme l’un des « centres du monde » et reste aujourd’hui un lieu important de pèlerinage.
`,

                details: `
Le complexe de Mizdakhan a été actif du IVe siècle avant notre ère jusqu’au XIVe siècle et comprend plusieurs couches historiques correspondant à différentes époques.

📌 Composition du complexe :
- Gyaur-Kala — vestiges d’une ancienne ville-forteresse
- La colline de Nazloumkhân — associée au tombeau légendaire d’une princesse
- La colline de l’Amitié des peuples — regroupant des mausolées de différentes périodes

📌 Légendes :
Selon les traditions locales, l’histoire d’amour tragique liée à la princesse Nazloumkhân a transformé ce lieu en un endroit mystérieux et légendaire.

📌 Importance historique :
- L’une des plus anciennes nécropoles de la région du Khorezm
- Conserve les traces des traditions funéraires zoroastriennes et islamiques
- Représente plusieurs milliers d’années d’histoire archéologique

Aujourd’hui encore, Mizdakhan est considéré comme un lieu sacré et est visité par les habitants et les pèlerins.
`,

                facts: [
                    "Située près du district de Khodjeyli",
                    "Utilisée depuis plus de 2 500 ans",
                    "Son histoire remonte au IVe siècle avant notre ère",
                    "Comprend les vestiges de l’ancienne ville-forteresse Gyaur-Kala",
                    "La colline de Nazloumkhân est liée à une princesse légendaire",
                    "Conserve des mausolées de différentes périodes historiques",
                    "Présente des traces des traditions funéraires zoroastriennes et islamiques",
                    "L’une des plus anciennes nécropoles du Khorezm",
                    "Toujours visitée comme lieu sacré",
                    "Couvre plusieurs milliers d’années d’histoire",
                    "Selon les légendes, elle serait l’un des « centres du monde »",
                    "Un important monument culturel du Karakalpakstan",
                    "Reflète les traditions funéraires de différents peuples et époques",
                    "Une source scientifique précieuse pour les chercheurs",
                    "Proposée pour une inscription potentielle au patrimoine mondial de l’UNESCO"
                ],

                images: [mizdaxon1, mizdaxon2, mizdaxon3,]
            },
            {
                title: "Musée d’art Savitsky",

                content: `
Le musée national des arts du Karakalpakstan nommé d’après Savitsky est situé à Noukous et possède l’une des plus grandes collections d’art d’avant-garde russe au monde.

Le musée a été créé grâce à l’artiste et archéologue Igor Savitsky, qui a rassemblé et préservé des œuvres d’art interdites ou oubliées pendant la période soviétique.

Surnommé le « Louvre dans le désert », ce musée occupe une place exceptionnelle dans l’histoire mondiale de l’art.
`,

                details: `
Le musée a été fondé en 1966 par Igor Savitsky.

📌 À propos de la collection :
- Plus de 90 000 œuvres et objets sont conservés
- Une importante collection d’art avant-gardiste russe
- Des exemples d’art décoratif et appliqué d’Asie centrale
- Des découvertes archéologiques anciennes sont également exposées

📌 À propos d’Igor Savitsky :
Entre les années 1950 et 1980, Savitsky a rassemblé les œuvres d’artistes rejetés par la politique artistique officielle soviétique. En les transportant à Noukous, il a permis de préserver de nombreux chefs-d’œuvre menacés de disparition.

📌 Importance historique :
Le musée possède une valeur exceptionnelle non seulement artistique mais aussi historique, car il conserve l’héritage d’artistes ignorés ou interdits pendant l’époque soviétique.

Aujourd’hui, le musée est installé dans un bâtiment moderne et attire des chercheurs, des spécialistes de l’art et des visiteurs du monde entier.
`,

                facts: [
                    "Situé dans la ville de Noukous",
                    "Fondé en 1966 par Igor Savitsky",
                    "Conserve plus de 90 000 œuvres et objets",
                    "Possède l’une des plus grandes collections d’avant-garde russe",
                    "Surnommé le « Louvre dans le désert »",
                    "Préserve des œuvres interdites durant la période soviétique",
                    "Présente des exemples d’art appliqué d’Asie centrale",
                    "Expose également des découvertes archéologiques",
                    "Possède une importance internationale dans l’histoire de l’art",
                    "Installé dans un bâtiment moderne",
                    "Attire des visiteurs du monde entier",
                    "Une source précieuse pour l’étude de l’histoire de l’art",
                    "Reconnu internationalement sous le nom de Savitsky",
                    "Considéré comme un symbole culturel du Karakalpakstan",
                    "Organise régulièrement des expositions spéciales"
                ],

                images: [savitskiy1, savitskiy2, savitskiy3,]
            },
            {
                title: "Dakhma de Chilpik",

                content: `
Chilpik est une ancienne dakhma zoroastrienne située sur une haute colline près de l’Amou-Daria. Elle est considérée comme l’un des monuments les plus uniques et mystérieux d’Ouzbékistan.

Cette construction circulaire est liée aux anciennes traditions funéraires du zoroastrisme, selon lesquelles les défunts étaient exposés selon des rites religieux spécifiques.

Grâce à sa forme inhabituelle et à son histoire fascinante, Chilpik attire les voyageurs et les chercheurs du monde entier.
`,

                details: `
La dakhma de Chilpik aurait été construite entre le Ier siècle avant notre ère et le Ier siècle de notre ère.

📌 Tradition zoroastrienne :
Selon les croyances zoroastriennes, le corps d’un défunt ne devait pas souiller la terre, l’eau ou le feu. C’est pourquoi les corps étaient déposés sur des dakhmas élevées, où ils étaient purifiés par le soleil et les oiseaux. Ensuite, les os étaient placés dans des récipients spéciaux appelés ossuaires.

📌 Architecture :
- Structure circulaire construite au sommet d’une colline
- Située environ 30 mètres au-dessus de la plaine environnante
- Présence de murs anciens ayant des fonctions rituelles et protectrices

📌 Importance historique :
- L’un des rares monuments zoroastriens conservés en Asie centrale
- Une source importante pour l’étude de la religion et des traditions de l’ancien Khorezm
- Certains chercheurs pensent que le site aurait également pu servir aux observations astronomiques

Aujourd’hui, Chilpik continue d’attirer les visiteurs grâce à son atmosphère mystérieuse, son calme et ses paysages impressionnants.
`,

                facts: [
                    "Située près de Noukous, au bord de l’Amou-Daria",
                    "Construite vers le Ier siècle avant notre ère",
                    "Utilisée pour les rites funéraires zoroastriens",
                    "Possède une forme circulaire unique",
                    "La colline s’élève à environ 30 mètres au-dessus du paysage",
                    "Les corps étaient exposés au soleil et aux oiseaux selon les traditions",
                    "Les os étaient placés dans des ossuaires",
                    "L’un des rares monuments zoroastriens conservés d’Asie centrale",
                    "Fournit des informations importantes sur la religion de l’ancien Khorezm",
                    "Aurait peut-être servi pour des observations astronomiques",
                    "Connue pour son atmosphère mystérieuse et paisible",
                    "Visitée par les touristes et les chercheurs",
                    "L’un des monuments les plus insolites du Karakalpakstan",
                    "Offre une vue magnifique au coucher du soleil",
                    "Un site essentiel pour l’étude de l’histoire du zoroastrisme"
                ],

                images: [chilpiq1, chilpiq2, chilpiq3,]
            },
            {
                title: "Ancienne forteresse de Koy-Krylgan-Kala",

                content: `
Koy-Krylgan-Kala est une grande cité-forteresse antique située au Karakalpakstan, qui fut l’un des centres importants de la région du Khorezm pendant la période kouchane.

La ville possédait une organisation circulaire unique ainsi qu’un système avancé d’urbanisme et de défense pour son époque.

Koy-Krylgan-Kala joue un rôle important dans l’étude de l’architecture urbaine ancienne et des traditions de construction du Khorezm.
`,

                details: `
Koy-Krylgan-Kala a été active du IVe siècle avant notre ère jusqu’au IVe siècle de notre ère.

📌 Organisation de la ville :
- Une forme circulaire unique pour une ville antique
- Deux rangées de murailles défensives
- Un palais du souverain situé dans la partie centrale
- Des quartiers résidentiels et des zones artisanales autour de la forteresse

📌 Découvertes archéologiques :
- Des monnaies datant de la période kouchane
- Des objets en céramique et en métal
- Des restes d’armes et d’équipements militaires

📌 Importance historique :
- Témoigne du niveau avancé de l’urbanisme ancien du Khorezm
- Confirme les relations commerciales et culturelles avec l’Empire kouchan
- Représente un élément important du réseau des anciennes villes de la région

Aujourd’hui, les ruines de Koy-Krylgan-Kala sont conservées et les recherches archéologiques se poursuivent encore sur le site.
`,

                facts: [
                    "Située sur le territoire du Karakalpakstan",
                    "A existé du IVe siècle avant notre ère au IVe siècle de notre ère",
                    "Possède une organisation circulaire exceptionnelle",
                    "Des doubles murailles défensives sont encore visibles",
                    "Un palais du souverain se trouvait au centre",
                    "Des monnaies de l’époque kouchane ont été découvertes",
                    "Des objets en céramique et en métal ont été retrouvés",
                    "Montre le développement de l’urbanisme ancien du Khorezm",
                    "Confirme les liens avec l’Empire kouchan",
                    "Faisait partie du système des forteresses « Ellik Qala »",
                    "Les recherches archéologiques continuent aujourd’hui",
                    "Un exemple remarquable d’urbanisme antique",
                    "Important pour l’étude des systèmes défensifs anciens",
                    "Une source scientifique précieuse pour les historiens",
                    "Un monument peu connu mais précieux du Karakalpakstan"
                ],

                images: [qoyqirilgan1, qoyqirilgan2, qoyqirilgan3,]
            }



        ]
    }

};

export default qoraqalpogiston;